export enum ErpPositionSlMode {
  NUR_KOMPONENTEN_EINFUEGEN_MIT_STUECKLISTE_ALS_TITEL = 'NUR_KOMPONENTEN_EINFUEGEN_MIT_STUECKLISTE_ALS_TITEL',
  STUECKLISTE_MIT_SUB_POSITIONEN_IM_LANGTEXT = 'STUECKLISTE_MIT_SUB_POSITIONEN_IM_LANGTEXT',
  STUECKLISTE_OOHNE_SUB_POSITIONEN_IM_LANGTEXT = 'STUECKLISTE_OOHNE_SUB_POSITIONEN_IM_LANGTEXT',
  NUR_KOMPONENTEN_EINFUEGEN = 'NUR_KOMPONENTEN_EINFUEGEN',
  STUECKLISTE_WIRD_ZU_ARTIKEL_MIT_SUB_POSITIONEN_IM_LANGTEXT = 'STUECKLISTE_WIRD_ZU_ARTIKEL_MIT_SUB_POSITIONEN_IM_LANGTEXT',
  STUECKLISTE_WIRD_ZU_ARTIKEL_OHNE_SUB_POSITIONEN_IM_LANGTEXT = 'STUECKLISTE_WIRD_ZU_ARTIKEL_OHNE_SUB_POSITIONEN_IM_LANGTEXT',
  NOT_SELECTED = 'NOT_SELECTED',
}
